import { formatNumber } from "helpers/formatNumber";
import { IFRCalculationResult } from "models/HaulPay";
import styles from "./style.module.scss";
import clsx from "clsx";

interface ISharedValue {
  frCalculation: IFRCalculationResult;
  isMarginAdvance?: boolean;
}

export default function FrResult({
  frCalculation,
  isMarginAdvance = false
}: Readonly<ISharedValue>) {
  const {
    contract_type: contractType,
    payment_profile_discount_rate: carrierRate,
    total_comfreight_fee: totalFee,
    payment_profile_fee: paymentProfileFee,
    factoring_fee: yourFee,
    payment_profile_payable: carrierPay,
    factoring_payable: yourPay,
    carrier_total_amount: carrierTotalAmount,
    self_finance_total_amount: debitAmount,
    broker_self_finance_fee: selfFinanceFee,
    self_finance_fee_rate_info: selfFinanceFeeRateInfo,
    discount_rate_comfreight: QPRate,
    reserve_amount: reserveAmount,
    factoring_fee_split_rate: carrierQPRate,
    carrier_line_haul: carrierLineHaul,
    broker_carrier_advance: brokerLineHaul,
    qp_total_fee: QPTotalFee,
    carrier_qp_fee: carrierQPFee
  } = frCalculation;

  return (
    <div>
      {contractType.startsWith("SELF_FINANCE") ? (
        <ul className={styles.selfFinancedPayment}>
          <li className="pb-2">
            <span>Carrier</span>
            <span>Broker</span>
          </li>
          <li>
            <div>
              <span>Line haul: </span>
              <span className="text-success">{formatNumber(carrierLineHaul / 100, 2)}</span>
            </div>
            <div>
              <span>Line haul: </span>
              <span className="text-error">{formatNumber(brokerLineHaul / 100, 2)}</span>
            </div>
          </li>
          <li>
            <div>
              <span>QP Rate {QPRate}%: </span>
              <span className="text-error">{formatNumber(QPTotalFee / 100, 2)}</span>
            </div>
            <div>
              <span>Self finance fee: </span>
              <span className="text-error">{formatNumber(selfFinanceFee / 100, 2)} </span>
              <span>({selfFinanceFeeRateInfo})</span>
            </div>
          </li>
          <li>
            <div>
              <span>Carrier QP Fee {100 - carrierQPRate}%: </span>
              <span className="text-error">{formatNumber(carrierQPFee / 100, 2)}</span>
            </div>
            <div>
              <span>Gross QP Profit: </span>
              <span className="text-success">{formatNumber(paymentProfileFee / 100, 2)}</span>
            </div>
          </li>
          <li className={clsx(styles.result)}>
            <div className="mt-2">
              <span>Carrier Pay: </span>
              <span className="text-success">{formatNumber(carrierTotalAmount / 100, 2)}</span>
            </div>
            <div className="mt-2">
              <span>Debit Amount: </span>
              <span className="text-error">{formatNumber(debitAmount / 100, 2)}</span>
            </div>
          </li>
          <li>
            <span></span>
            <div>
              <span>Net QP Profit: </span>
              <span className={brokerLineHaul >= debitAmount ? "text-success" : "text-error"}>
                {formatNumber((brokerLineHaul - debitAmount) / 100, 2)}
              </span>
            </div>
          </li>
        </ul>
      ) : (
        <ul className={styles.defaultPayment}>
          <li>
            {contractType !== "NON_FACTORED_BILL_OUT" ? (
              <div>
                <span>Carrier&apos;s Rate: </span>
                <span className="text-error">{carrierRate}%</span>
              </div>
            ) : (
              <span></span>
            )}
            <div>
              <span>Total Fee: </span>
              <span className="text-error">{formatNumber(totalFee / 100, 2)}</span>
            </div>
          </li>
          {isMarginAdvance && (
            <li className="font-bold">
              <span></span>
              <div>
                <span>Reserve Holdback: </span>
                <span className="text-error">{formatNumber(reserveAmount / 100, 2)}</span>
              </div>
            </li>
          )}
          <li className="font-bold">
            {contractType !== "NON_FACTORED_BILL_OUT" ? (
              <div>
                <span>Your Carrier&apos;s Fee: </span>
                <span className="text-error">{formatNumber(paymentProfileFee / 100, 2)}</span>
              </div>
            ) : (
              <span></span>
            )}
            <div>
              <span>Your Fee: </span>
              <span className="text-error">{formatNumber(yourFee / 100, 2)}</span>
            </div>
          </li>
          <li className={styles.result}>
            {contractType !== "NON_FACTORED_BILL_OUT" ? (
              <div className="mobile:text-start">
                <span>Your Carrier&apos;s Pay: </span>
                <span className="text-success">{formatNumber(carrierPay / 100, 2)}</span>
              </div>
            ) : (
              <span></span>
            )}
            <div className="mobile:text-end">
              <span>Your Pay: </span>
              <span className="text-success">{formatNumber(yourPay / 100, 2)}</span>
            </div>
          </li>
        </ul>
      )}
    </div>
  );
}
